var map = {
	"./arrow-up.svg": 46343,
	"./arthera.svg": 3289,
	"./avax.svg": 95462,
	"./avax/busd.svg": 95963,
	"./avax/dai.e.svg": 15690,
	"./avax/dyp.svg": 28648,
	"./avax/idyp.svg": 90897,
	"./avax/link.e.svg": 20802,
	"./avax/png.svg": 22982,
	"./avax/qi.svg": 73075,
	"./avax/usdc.e.svg": 8797,
	"./avax/usdcIcon.svg": 74969,
	"./avax/usdt.e.svg": 20902,
	"./avax/usdt.svg": 46069,
	"./avax/wavax.svg": 89130,
	"./avax/wbtc.e.svg": 42902,
	"./avax/weth.e.svg": 47330,
	"./avax/xava.svg": 66167,
	"./avaxActive.svg": 33308,
	"./bnb.svg": 93254,
	"./bnbActive.svg": 97564,
	"./bsc/btcb.svg": 10530,
	"./bsc/busd.svg": 52213,
	"./bsc/cake.svg": 64179,
	"./bsc/eth.svg": 5340,
	"./bsc/usdcIcon.svg": 12887,
	"./bsc/usdt.svg": 5763,
	"./bsc/wbnb.svg": 9148,
	"./carrot.svg": 25161,
	"./caws-bg.svg": 99294,
	"./check.svg": 34692,
	"./copy.svg": 1835,
	"./dai.svg": 85426,
	"./dropdownVector.svg": 2530,
	"./dyp.svg": 22387,
	"./ellipse.svg": 13838,
	"./ellipse2.svg": 26688,
	"./empty.svg": 69047,
	"./esc.svg": 54475,
	"./escActive.svg": 60225,
	"./eth.svg": 16877,
	"./ethActive.svg": 77659,
	"./fsn.svg": 83577,
	"./greenarrow.svg": 37268,
	"./idyp.svg": 8136,
	"./more-info.svg": 38996,
	"./orangearrow.svg": 67497,
	"./poolStatsIcon.svg": 62252,
	"./poolsCalculatorIcon.svg": 81750,
	"./purpleStat.svg": 32212,
	"./referral.svg": 31199,
	"./stats.svg": 5205,
	"./statsLinkIcon.svg": 23366,
	"./tooltipIcon.svg": 69010,
	"./toppick.svg": 50718,
	"./usdc.svg": 38383,
	"./usdcIcon.svg": 35552,
	"./usdt.svg": 21440,
	"./wallet.svg": 39299,
	"./wavax.svg": 16497,
	"./wbtc.svg": 40412,
	"./weth.svg": 63104,
	"./whiteArrowUp.svg": 5533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83142;